let amrToBase64 = {}

let readBlobAsDataURL = (blob, callback) => {
  let reader = new FileReader()
  reader.onload = function (e) {
    callback(e.target.result)
  }
  reader.readAsDataURL(blob)
}

let fetchBlob = (url, callback) => {
  let xhr = new XMLHttpRequest()
  xhr.open('GET', url)
  xhr.responseType = 'blob'
  xhr.onload = function () {
    callback(this.response)
  }
  xhr.onerror = function () {
    // alert('Failed to fetch ' + url)
  }
  xhr.send()
}

// let fetchBlob = (url, callback) => {
//   console.log(url)
//   window.$.ajax({
//     url: url,
//     type: 'GET',
//     dataType: 'blob',
//     success: function (data) {
//       callback(data)
//     },
//     error: function (err) {
//       console.log(err)
//     }
//   })
// }

amrToBase64.init = (url, callback) => {
  fetchBlob(url, (data) => {
    readBlobAsDataURL(data, function (dataurl) {
      callback(dataurl)
    })
  })
}

export default amrToBase64
